import { Component, EventEmitter, HostListener, Input, OnInit, Output, signal, SimpleChanges, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators, ReactiveFormsModule } from '@angular/forms';
import { BehaviorSubject, combineLatest, forkJoin, Observable, of, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith, takeUntil, } from 'rxjs/operators';
import { RegistationUtilitiesService } from '../../services/registation-utilities.service';
import { MatDialog } from '@angular/material/dialog';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { RegistrationModel } from '../../models/RegistrationModel';
import { inputValidationValidator, noHtmlTagsValidator, } from 'src/app/shared/Validators/special-character-validation';
import { RegistrationVerifyingEmailComponent } from '../registration-verifying-email/registration-verifying-email.component';
import { AccountService } from 'src/app/services/accountService/account.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { StepperService } from 'src/app/services/stepperService/stepper.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { MatRadioChange, MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatCheckboxChange, MatCheckbox } from '@angular/material/checkbox';
import { OtpActionType, OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { SignUpContentServiceService } from '../../services/sign-up-content-service.service';
import { ContentService } from 'src/app/modules/cam/services/content.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { ContentDialogComponent } from 'src/app/shared/components/dialogs/content-dialog/content-dialog.component';
import { environment } from 'src/environments/environment';
import { NgIf, NgStyle, NgFor, NgClass, DatePipe } from '@angular/common';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { AutoBlurSelectDirective } from '../../../../shared/directive/auto-select-blur.directive';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { DateOfBirthCalendarComponent } from '../date-of-birth-calendar/date-of-birth-calendar.component';
import { ExpiryDateComponent } from '../../../cam/components/expiry-date/expiry-date.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatExpansionPanelActionRow } from '@angular/material/expansion';
import { MatProgressSpinner } from '@angular/material/progress-spinner';


export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}

export const _filter = (
  opt: { name: string; code: string }[],
  value: string
): { name: string; code: string }[] => {
  const filterValue = value.toLowerCase();
  return opt.filter((item) => item.name.toLowerCase().includes(filterValue));
};

@Component({
    selector: 'app-business-owner-info',
    templateUrl: './business-owner-info.component.html',
    styleUrls: ['./business-owner-info.component.scss'],
    imports: [NgIf, ReactiveFormsModule, NgSelectComponent, AutoBlurSelectDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, DateOfBirthCalendarComponent, ExpiryDateComponent, NgStyle, MatSelect, NgFor, MatOption, NgClass, MatRadioGroup, MatRadioButton, MatCheckbox, MatButton, MatExpansionPanelActionRow, MatProgressSpinner, DatePipe]
})
export class BusinessOwnerInfoComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  private visibilitySource = new BehaviorSubject<{ [key: string]: boolean }>({
    isDOBCalendarVisible: false,
    isInfantCallCalendarVisible: false,
    isPPCalendarVisible: false,
  });
  private destroy$ = new Subject<void>();
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false,
    isExpiaryCalendarVisible: false,
    // Add other child components here
  };
  @Output() FormFilled = new EventEmitter<void>();
  @Output() EditBusinessownerr = new EventEmitter<void>();
  @Input() corporateInfo: any;
  @Input() AgreeDataUsee: any;
  @Input() showbusinessOwnerform: boolean = false;
  @Input() OwnerHeading: boolean = true;
  @Input() EditLinkOwner: boolean = false;
  filteredCountries: any;
  PreviousCountryCode: any;
  emaill: string = ''; // fOR TESTING ONLY DELETE LATER
  otp: string = '';
  Mobile: string = '';
  CountryCode: string = '';
  mobilecode: any;
  PrevNationality: string = '';
  changedNationality: any;
  Sitekey: any = '5d6e5934-23e4-472c-89ec-bdb86b8c96a4';
  hcaptcha: any;
  selectedCountryName: string | undefined; // To hold the selected country name  showbusinessOwnerform
  hideNewPassword: boolean = true;
  hideConfirmPassword: boolean = true;
  businessOwnerForm!: FormGroup;
  countriesLists: any[] = [];
  selectedExpiryDate: Date | null = null;
  stateForm = this.fb.group({
    stateGroup: this.fb.control<{
      name: string;
      code: string;
      countryFlag: string;
      isdCode: string;
    } | null>(null, Validators.required),
  });
  stateGroupOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<
    StateGroup[]
  >([]).asObservable();
  selectedDOB: any;
  documentType = [
    { value: 'A', viewValue: 'National ID' },
    { value: 'I', viewValue: 'IQAMA' },
    { value: 'P', viewValue: 'Passport' },
  ];
  get selectedDocumentTypeLabel(): string {
    const value = this.businessOwnerForm.get('documentType')?.value;
    const match = this.documentType.find((d) => d.value === value);
    return match?.viewValue ?? '-';
  }
  get documentLabel(): string {
    // Return the current document name from CommonObj, or default
    return this.CommonObj?.docName || 'Document no.';
  }
  newCustomCountries: any[] = [];
  CommonObj = {
    docType: '',
    docName: '',
  };
  commonObj: any = {
    isSubmitting: false,
  };
  hide = signal(true);
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }
  content: any;
  onBoardContent: any;
  otpChecksum: any;
  otpsendverify: boolean = false;
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  constructor(
    private _StepperService: StepperService,
    private fb: FormBuilder,
    public _ApiService: ApiService,
    private Utills: RegistationUtilitiesService,
    public x: MatDialog,
    private dialog: MatDialog,
    public _CommonService: CommonService,
    private accountService: AccountService,
    private visibilityService: ComponentVisibilityService,
    private _DataLayerService: DataLayerService,
    private contentService: SignUpContentServiceService,
    private onBoardContentService: ContentService,
    private _ToastrApiService: ToastrApiService,
    private readonly dictionaryContentService: DisctionaryContent
  ) {
    this.businessOwnerForm = this.fb.group(
      {
        EmpCode: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(9), Validators.pattern(/^[a-zA-Z0-9]*$/),],],
        NationalID: ['', [inputValidationValidator()],],
        Nationality: [null, [Validators.required]],
        countryOfResidence: [null, [Validators.required]],
        DOB: ['', [Validators.required]],
        title: ['', [Validators.required]],
        firstName: ['', [Validators.required, inputValidationValidator(), Validators.minLength(2), Validators.maxLength(50), noHtmlTagsValidator(),],], //noHtmlTagsValidator
        lastName: ['', [Validators.required, Validators.minLength(2), inputValidationValidator(), Validators.maxLength(50), noHtmlTagsValidator(),],],
        jobTitle: ['', [Validators.required, Validators.minLength(2), inputValidationValidator(), Validators.maxLength(50), noHtmlTagsValidator(),],], //designation
        email: ['', [Validators.required, Validators.email],],
        phoneNumber: ['',[Validators.minLength(8), Validators.maxLength(12)]],
        telephone: ['', [Validators.maxLength(15), Validators.minLength(6)]],
        // newPassword: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(30), this.passwordStrengthValidator.bind(this)]],
        // confirmPassword: ['', Validators.required],
        verifyWith: ['', Validators.required],
        acceptTerms: [false, Validators.requiredTrue],
        agreeDataUse: [false],
        gender: ['Male', Validators.required],
        documentType: ['', Validators.required],
        docExpiry: ['', Validators.required],
      });
    this.visibilityService.visibility$
      .pipe(takeUntil(this.destroy$))
      .subscribe((visibility) => {
        this.isChildVisible = visibility;
      });
  }


  // Utility: normalize domain string
  private normalizeDomain(raw: any): string | null {
    if (!raw) return null;
    let d = String(raw).trim().toLowerCase();
    // remove leading @ or http/https/www
    d = d
      .replace(/^@/, '')
      .replace(/^https?:\/\//, '')
      .replace(/^www\./, '');
    // remove any trailing slashes
    d = d.replace(/\/+$/, '');
    return d || null;
  }
  /**
   * Validates that the email contains the configured domain.
   * - Handles hasCompanyDomain as boolean or string ('yes')
   * - Accepts domain names with or without TLD (e.g., "quadlab" or "quadlab.com")
   * - Clears stale errors properly
   */
  validateEmailDomain() {
    const corporateForm: any = this.corporateInfo;
    const emailControl = this.businessOwnerForm?.get('email') as FormControl;
    if (!corporateForm || !emailControl || !emailControl.value) {
      return;
    }
    // ---- normalize hasCompanyDomain ----
    const hasDomainRaw = corporateForm.hasCompanyDomain;
    const hasDomain =
      hasDomainRaw === true ||
      String(hasDomainRaw).toLowerCase() === 'yes' ||
      String(hasDomainRaw).toLowerCase() === 'true';
    // ---- normalize domain ----
    const domain = this.normalizeDomain(corporateForm.domainName);
    // if domain validation not required, clear domainMismatch error if exists
    if (!hasDomain || !domain) {
      const currentErrors = emailControl.errors;
      if (currentErrors && currentErrors['domainMismatch']) {
        const { domainMismatch, ...remainingErrors } = currentErrors;
        emailControl.setErrors(
          Object.keys(remainingErrors).length ? remainingErrors : null
        );
        emailControl.updateValueAndValidity();
      }
      return;
    }
    const email = (emailControl.value || '').toLowerCase().trim();
    if (!email.includes('@')) {
      // If email doesn't have @, don't validate domain yet
      return;
    }
    const emailDomain = email.split('@')[1];
    if (!emailDomain) {
      return;
    }
    // allow domain with or without TLD
    const validDomains = domain.includes('.')
      ? [domain]
      : [domain, `${domain}.com`];
    const isMatch = validDomains.some((d) => emailDomain === d);
    // Get current errors (preserve all existing errors)
    const currentErrors = { ...(emailControl.errors || {}) };
    if (!isMatch) {
      // Add domainMismatch error, preserve all other errors
      emailControl.setErrors({ ...currentErrors, domainMismatch: true });
      emailControl.markAsTouched();
      emailControl.markAsDirty();
    } else {
      // Remove only domainMismatch error, keep all other errors
      if (currentErrors['domainMismatch']) {
        const { domainMismatch, ...remainingErrors } = currentErrors;
        emailControl.setErrors(
          Object.keys(remainingErrors).length ? remainingErrors : null
        );
      }
    }
  }

  get isJoinNowDisabled(): boolean {
    if (this.stateForm?.invalid) return true;
    if (!this.businessOwnerForm) return true;
    if (!this.businessOwnerForm.invalid) return false;

    // Allow "Join now" click when the form is invalid only because of
    // `email.domainMismatch` (so we can show the domain mismatch popup).
    const invalidControlKeys = Object.keys(this.businessOwnerForm.controls).filter((key) => {
      return this.businessOwnerForm.get(key)?.invalid;
    });

    if (
      invalidControlKeys.length === 1 &&
      invalidControlKeys[0] === 'email' &&
      this.businessOwnerForm.get('email')?.hasError('domainMismatch')
    ) {
      return false;
    }

    return true;
  }
  popUp(registrationModel: RegistrationModel) {
    registrationModel.actionType = OtpActionType.REGISTER;
    const xRef = this.x
      .open(EmailVerificationComponent, {
        data: registrationModel,
        disableClose: true,
      })
      .afterOpened()
      .subscribe(() => {
        (document.querySelector('html') as any).style.top = 0;
      });
  }
  ngOnChange(): void {
      console.log(this.corporateInfo)
    this.showbusinessOwnerform = !this.showbusinessOwnerform;
    if (this.AgreeDataUsee == false) {
      const agreeDataUse = this.businessOwnerForm.get('agreeDataUse');
      agreeDataUse?.clearValidators();
      agreeDataUse?.updateValueAndValidity();
    }
    window.onCaptchaSuccess = (token: string) =>
      this.handleCaptchaSuccess(token);
  }
  ngAfterViewInit() {
    this.renderHCaptcha();
  }

  ngOnChanges(changes: SimpleChanges): void {
  console.log(this.corporateInfo)

    // During Edit flow, `corporateInfo` may be populated asynchronously.
    // If it changes and email already has value, re-run domain validation so
    // `domainMismatch` error state is always in sync.
    if (changes['corporateInfo'] && this.businessOwnerForm) {
      const emailControl = this.businessOwnerForm.get('email') as
        | FormControl
        | null;
      if (emailControl?.value) {
        this.validateEmailDomain();
      }
    }
  }

  ngOnInit(): void {

    console.log(this.corporateInfo)
    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      console.log('response of forkJoin', res);
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });
    console.log(this.content)
    this.onBoardContentService.content$
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.onBoardContent = res;
        console.log("onBoardContent",this.onBoardContent)
      });
    this.onBoardContentService.loadContent().subscribe();

    this.showbusinessOwnerform = !this.showbusinessOwnerform;
    this.showbusinessOwnerform = !this.showbusinessOwnerform;
    this.businessOwnerForm.patchValue({ verifyWith: 'Email' });
    this.businessOwnerForm.get('newPassword')?.valueChanges.subscribe(() => {
      this.checkPasswordMatch();
    });
    this.businessOwnerForm
      .get('confirmPassword')
      ?.valueChanges.subscribe(() => {
        this.checkPasswordMatch();
      });
    this.businessOwnerForm
      .get('Nationality')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe((value) => {
        this.changedNationality = value;
        this.updateDocumentType();
      });
    this.businessOwnerForm
      .get('countryOfResidence')
      ?.valueChanges.pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateDocumentType();
      });
    this.businessOwnerForm.get('telephone')?.setValue('');
    // Disable documentType dropdown - it will be auto-populated based on nationality/residence
    this.businessOwnerForm.get('documentType')?.disable();
    this._ApiService
      .getCountriesData()
      .then(($res) => {
        this.newCustomCountries =
          this._CommonService.groupCountriesFilter($res);
        this.groupCountries($res);
        this.nationalityGroupCountries($res);
      })
      .catch(($err) => { });
    this.stateForm.valueChanges
      .pipe(
        startWith(''),
        map((value) => this.filterCountries(value))
      )
      .subscribe((filteredCountries) => {
        this.filteredCountries = filteredCountries;
        this.groupCountries(this.filteredCountries);
      });
    this.showbusinessOwnerform = !this.showbusinessOwnerform;
    const agreeDataUse = this.businessOwnerForm.get('agreeDataUse');
    agreeDataUse?.clearValidators();
    agreeDataUse?.updateValueAndValidity();
    // Debounced email domain validation - only runs after user stops typing
    this.businessOwnerForm
      .get('email')
      ?.valueChanges.pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => {
        // Only validate if corporateInfo is available
        if (this.corporateInfo) {
          this.validateEmailDomain();
        }
      });
    window.onCaptchaSuccess = (token: string) =>
      this.handleCaptchaSuccess(token);



  //   this.stateForm.get('stateGroup')?.valueChanges
  //   .pipe(takeUntil(this.destroy$))
  //   .subscribe(() => {
  //     this.updatePhoneNumberValidators();
  //   });
    
  // // Initial call to set validators
  // this.updatePhoneNumberValidators();

  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event?.target as HTMLElement;
    const isDobInput = target.getAttribute('formControlName');
    if (!isDobInput) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible['isExpiaryCalendarVisible'] = false;

      this.businessOwnerForm.get('DOB')?.setValidators([Validators.required]);
      this.businessOwnerForm.get('DOB')?.updateValueAndValidity();
    }
  }
  // nationalIdOrNationalityRequired(): ValidatorFn {
  //   return (formGroup: AbstractControl): ValidationErrors | null => {
  //     const nationalId = formGroup.get('NationalID')?.value;
  //     const nationality = formGroup.get('Nationality')?.value;
  //     const nationalIdControl = formGroup.get('NationalID');
  //     const nationalityControl = formGroup.get('Nationality');
  //     // Clear 'required' error initially from both controls
  //     nationalIdControl?.setErrors(
  //       nationalIdControl?.errors
  //         ? { ...nationalIdControl.errors, required: null }
  //         : null
  //     );
  //     nationalityControl?.setErrors(
  //       nationalityControl?.errors
  //         ? { ...nationalityControl.errors, required: null }
  //         : null
  //     );
  //     // Validation rule: If one field is filled, the other becomes required
  //     if ((nationalId && !nationality) || (nationality && !nationalId)) {
  //       if (!nationalId) {
  //         nationalIdControl?.setErrors({ required: true });
  //       }
  //       if (!nationality) {
  //         nationalityControl?.setErrors({ required: true });
  //       }
  //     }
  //     // If both fields are empty, remove the 'required' error from both
  //     if (!nationalId && !nationality) {
  //       nationalIdControl?.setErrors(
  //         nationalIdControl?.errors
  //           ? { ...nationalIdControl.errors, required: null }
  //           : null
  //       );
  //       nationalityControl?.setErrors(
  //         nationalityControl?.errors
  //           ? { ...nationalityControl.errors, required: null }
  //           : null
  //       );
  //     }
  //     return null;
  //   };
  // }
  showComponent(componentKey: string, controlName?: string) {
    if (!Object.hasOwn(this.isChildVisible, componentKey)) {
      return;
    }
    Object.keys(this.isChildVisible).forEach((key) => {
      this.isChildVisible[key] = key === componentKey;
    });
    if (!!controlName) {
      this.businessOwnerForm
        .get(controlName)
        ?.removeValidators([Validators.required]);
      this.businessOwnerForm.get(controlName)?.updateValueAndValidity();
    }
  }
  hideComponent(componentKey: string) {
    if (Object.hasOwn(this.isChildVisible, componentKey)) {
      this.isChildVisible[componentKey] = false;
    }
  }
  onConfirm(componentKey: string) {
    this.hideComponent('isDOBCalendarVisible');
    this.verifyELM('nn');
  }
  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      const date = event.date ? new Date(event.date) : null; // Ensure date is valid or null
      this.selectedDOB = date; // Save the selected date
      const dobDateControl = this.businessOwnerForm.get('DOB');
      if (date) {
        // Format the date and set it in the form control
        const formattedDate = this.getFormattedDate(date);
        dobDateControl?.setValue(formattedDate); // Update the form control value
        dobDateControl?.clearValidators(); // Clear validators for a valid date
        // dobDateControl?.setValidators([Validators.required]); // Apply required validator
        // Trigger ELM verification if NationalID is already filled
        const nationalID = this.businessOwnerForm.get('NationalID')?.value;
        if (nationalID && nationalID.trim && nationalID.trim().length > 0) {
          setTimeout(() => {
            this.verifyELM('nn');
          }, 100);
        }
      } else {
        // Handle the case when the date is null
        dobDateControl?.setValue(null);
        // dobDateControl?.setValidators([Validators.required]); // Apply required validator
      }
      // Update form control validation status
      dobDateControl?.updateValueAndValidity();
      // Hide the DOB calendar
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
  }
  onDateSelected2(
    event: { type: string; date: Date | null },
    key: string
  ): void {
    if (event.type === 'dob') {
      if (
        !event.date ||
        event.date.toDateString() === new Date(0).toDateString()
      ) {
        return;
      }
      this.selectedExpiryDate = event.date ? new Date(event.date) : null;
      const formattedDate = this.getFormattedDate(this.selectedExpiryDate);
      this.businessOwnerForm.get('docExpiry')?.setValue(formattedDate);
      if (Object.hasOwn(this.isChildVisible, key)) {
        this.isChildVisible[key] = false;
      }
    }
  }
  OnSave(): void {
    this._DataLayerService.signup_save_continue({}, 'Travel Administrator Details Page', 'Company Details page');
    this._DataLayerService.registrationPageLanding('Review Details Page');
    if (this.businessOwnerForm.valid && this.stateForm.valid) {
      this.AgreeDataUsee = true;
      this._StepperService.RegstrationStepper('Review');
      this.FormFilled.emit();
      console.log('form value ', this.FormFilled)
      this.businessOwnerForm
        .get('agreeDataUse')
        ?.setValidators([Validators.requiredTrue]);
      this.businessOwnerForm.get('agreeDataUse')?.updateValueAndValidity();
    }
  }
  private buildELMPayload(): any | null {
    const dob = this.businessOwnerForm.get('DOB')?.value;
    const identity = this.businessOwnerForm.get('NationalID')?.value;
    // Use isoCode (2 characters like "SA") instead of code (ISD code like "+966")
    const nationality =
      this.businessOwnerForm.get('Nationality')?.value?.isoCode ||
      this.businessOwnerForm.get('Nationality')?.value?.code;
    // Check if DOB and identity are valid (not empty, null, or undefined)
    const hasValidDob =
      dob && (typeof dob === 'string' ? dob.trim().length > 0 : true);
    const hasValidIdentity =
      identity &&
      (typeof identity === 'string' ? identity.trim().length > 0 : true);
    if (!hasValidDob || !hasValidIdentity) {
      return null;
    }
    const formattedDob = this.convertToISODate(dob);
    switch (this.CommonObj.docType) {
      case 'nationalID':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };
      case 'iqama':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };
      default:
        return null; // passport → no ELM call
    }
  }
  verifyELM(_: any): void {
    // Ensure document type is updated before verification
    if (!this.CommonObj.docType) {
      this.updateDocumentType();
    }
    const dob = this.businessOwnerForm.get('DOB')?.value;
    const identity = this.businessOwnerForm.get('NationalID')?.value;
    // Skip if passport document type - enable fields for manual entry
    if (this.CommonObj.docType === 'passportNumber') {
      this.businessOwnerForm.get('firstName')?.enable();
      this.businessOwnerForm.get('lastName')?.enable();
      return;
    }
    // Disable firstName and lastName for nationalID and iqama (will be populated from ELM)
    this.businessOwnerForm.get('firstName')?.disable();
    this.businessOwnerForm.get('lastName')?.disable();
    const hasValidDob =
      dob && (typeof dob === 'string' ? dob.trim().length > 0 : true);
    const hasValidIdentity =
      identity &&
      (typeof identity === 'string' ? identity.trim().length > 0 : true);
    if (!hasValidDob || !hasValidIdentity) {
      return;
    }
    const payload = this.buildELMPayload();
    if (!payload) {
      return;
    }
    this.accountService.VerifyELMV1(payload).subscribe(
      (response) => {
        if (response?.data?.firstName) {
          this.businessOwnerForm.patchValue({
            firstName: response.data.firstName,
            lastName: response.data.lastName,
          });
        }
        this.businessOwnerForm.get('NationalID')?.setErrors(null);
        // Clear any ELM errors on success
        // const nationalIDControl = this.businessOwnerForm.get('NationalID');
        // const currentErrors = { ...(nationalIDControl?.errors || {}) };
        // if (currentErrors['elmError']) {
        //   const { elmError, ...remainingErrors } = currentErrors;
        //   nationalIDControl?.setErrors(
        //     Object.keys(remainingErrors).length ? remainingErrors : null
        //   );
        // }
      },
      (error) => {
        console.error('Error verifying ELM:', error);
        const ctrl = this.businessOwnerForm.get('NationalID');
        ctrl?.setErrors({
          ...(ctrl?.errors || {}),
          elmError: true,
        });
        // Clear first and last name on error
        this.businessOwnerForm.patchValue({
          firstName: '',
          lastName: '',
        });
        ctrl?.markAsTouched();
      }
    );
  }
  updateDocumentType(): void {
    const nationalityValue = this.businessOwnerForm.get('Nationality')?.value;
    const residenceValue = this.businessOwnerForm.get('countryOfResidence')?.value;
    const nationality = nationalityValue?.code || nationalityValue?.isoCode;
    const residence = residenceValue?.code || residenceValue?.isoCode;
    const documentTypeControl = this.businessOwnerForm.get('documentType');
    const nationalIDControl = this.businessOwnerForm.get('NationalID');
    const previousDocType = this.CommonObj.docType;

    if (!nationality || !residence) {
      this.CommonObj = { docType: '', docName: '' };
      documentTypeControl?.setValue('');
      // Enable firstName and lastName when document type is not determined
      this.businessOwnerForm.get('firstName')?.enable();
      this.businessOwnerForm.get('lastName')?.enable();

      // Clear validators for National ID when no document type is determined
      nationalIDControl?.clearValidators();
      nationalIDControl?.updateValueAndValidity();

      return;
    }

    // Check for both ISD code (+966) and ISO code (SA) for Saudi Arabia
    const isSaudiNationality = nationality === '+966' || nationality === 'SA';
    const isSaudiResidence = residence === '+966' || residence === 'SA';

    let newDocType = '';
    let newDocName = '';

    if (isSaudiNationality && isSaudiResidence) {
      newDocType = 'nationalID';
      newDocName = 'National ID';
      documentTypeControl?.setValue('A'); // National ID

      // Set validators for National ID: required, digits only, exactly 10 digits
      nationalIDControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d+$/), // Digits only
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

    } else if (isSaudiNationality && !isSaudiResidence) {
      newDocType = 'nationalID';
      newDocName = 'National ID';
      documentTypeControl?.setValue('A'); // National ID

      // For Saudi nationals abroad, don't require exactly 10 digits (may vary)
      nationalIDControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d+$/), // Digits only
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

    } else if (!isSaudiNationality && isSaudiResidence) {
      newDocType = 'iqama';
      newDocName = 'IQAMA';
      documentTypeControl?.setValue('I'); // IQAMA
      this.businessOwnerForm.patchValue({
        firstName: '',
        lastName: '',
      });

      // Set validators for IQAMA
      nationalIDControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d+$/), // Digits only
        Validators.minLength(10),
        Validators.maxLength(10)
      ]);

    } else if (!isSaudiNationality && !isSaudiResidence) {
      newDocType = 'passportNumber';
      newDocName = 'Passport';
      documentTypeControl?.setValue('P'); // Passport

      // Passport can have alphanumeric characters
      nationalIDControl?.setValidators([
        Validators.required,
        Validators.pattern(/^[a-zA-Z0-9]+$/),
        Validators.minLength(6),
        Validators.maxLength(12),
        // No pattern restriction for passport as it can be alphanumeric
      ]);
    }

    // Update CommonObj with new values
    this.CommonObj = {
      docType: newDocType,
      docName: newDocName,
    };

    // Update validators
    nationalIDControl?.updateValueAndValidity();

    // Enable/disable firstName and lastName based on document type
    if (newDocType === 'passportNumber') {
      this.businessOwnerForm.get('firstName')?.enable();
      this.businessOwnerForm.get('lastName')?.enable();
      // this.businessOwnerForm.patchValue({
      //   firstName: '',
      //   lastName: '',
      // });
    } else {
      // Disable for nationalID and iqama
      this.businessOwnerForm.get('firstName')?.disable();
      this.businessOwnerForm.get('lastName')?.disable();
    }

    // Clear NationalID and ELM errors if document type changed
    if (previousDocType && previousDocType !== newDocType && nationalIDControl) {
      nationalIDControl.setValue('');
      const currentErrors = { ...(nationalIDControl.errors || {}) };
      if (currentErrors['elmError']) {
        const { elmError, ...remainingErrors } = currentErrors;
        nationalIDControl.setErrors(
          Object.keys(remainingErrors).length > 0 ? remainingErrors : null
        );
      }
      nationalIDControl.updateValueAndValidity();
    }
  }

  getImageUrl(path: string): string {
    if (!path) return '';
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
    return `${base}/${cleanPath}`;
  }

  ////////BUSINESS OWNER EDIT MAKE AGREE DATA REQUIRED NULL
  EditBusinessowner(): void {
    this._DataLayerService.onCorporateTravel_info_edit('Administrator edit'); //GTM use
    this.businessOwnerForm.get('agreeDataUse')?.setValidators(null);
    this.businessOwnerForm.get('agreeDataUse')?.updateValueAndValidity();
    this._StepperService.RegstrationStepper('Travel Administrator');
    this.EditBusinessownerr.emit();
    const agreeDataUse = this.businessOwnerForm.get('agreeDataUse');
    agreeDataUse?.clearValidators(); // Clears all validators
    agreeDataUse?.updateValueAndValidity();
    // Ensure document type and field states are correctly set based on current nationality/residence
    // This maintains the original behavior: firstName/lastName disabled for NationalID/IQAMA, enabled for Passport
    this.updateDocumentType();
  }

  onSubmit(): void {
    const formValue = this.businessOwnerForm.getRawValue();
    // Company domain validation guard:
    // If `hasCompanyDomain` is enabled and the email domain doesn't match,
    // show popup and stop before sending OTP.
    const emailControl = this.businessOwnerForm.get('email') as FormControl | null;
    if (emailControl) {
      this.validateEmailDomain();
      if (emailControl.hasError('domainMismatch')) {
        this.dialog.open(ContentDialogComponent, {
          data: {
            imageSrc:
              '../../../../../assets/images/illustrations--SomthingWentWrong.svg',
            buttonText: 'Got it',
            buttonSearchAgain: 'Got it',
            description:
              'The email specified in Travel Admin details do not match the domain specified in Company Details. Please make the required changes to proceed.',
            contentTitle: 'Domain mismatch',
            showButton: true,
          },
          width: '480px',
        });
        this.commonObj.isSubmitting = false;
        return;
      }
    }

    if (!this.businessOwnerForm.valid || !this.stateForm.valid) {
      this.commonObj.isSubmitting = false;
      return;
    }

    this.commonObj.isSubmitting = true;
    this.sendOTP().subscribe({
      next: (res: any) => {
        this.otpChecksum = res?.data?.checksum || null;
        this.otpsendverify = true;
        const formValue = this.businessOwnerForm.getRawValue();
        const stateFormValue = this.stateForm.value;

        const registrationModel: RegistrationModel = {
          CompanyId: 'SAA',
          Title: formValue.title || '',
          FirstName: formValue.firstName || '',
          LastName: formValue.lastName || '',
          JobTitle: formValue.jobTitle || '',
          Email: formValue.email || '',
          CountryCode: this.getCountryNameByCode(this.corporateInfo.stateGroup) || '',
          Country: this.corporateInfo.stateGroup || '',
          CompanyName: this.corporateInfo.companyName || '',
          NatureOfBusiness: this.corporateInfo.natureOfBusiness || '',
          City: this.corporateInfo.cityControl || '',
          HeadOfficeAddress: this.corporateInfo.headOfficeAddress || '',
          CompanyUrl: this.normalizeUrl(this.corporateInfo.companyUrl) || '',
          Language: 'GB',
          verifyMode: (formValue.verifyWith).toLowerCase(),
          NoOFEmployees: String(this.corporateInfo.numberOfEmployee || '1'),
          Region: this.corporateInfo.stateGroup || this.corporateInfo.Country || 'KSA',
          registrationId: this.corporateInfo.registrationId,
          NationalID: formValue.NationalID || '',
          Nationality: formValue.Nationality?.isoCode || '',
          countryOfResidence: formValue.countryOfResidence?.isoCode || '',
          DOB: this._CommonService.formatDateToYMD(formValue.DOB) || '',
          EmpCode: formValue.EmpCode || '',
          PhoneNumber: formValue.phoneNumber || '',
          isdCode: stateFormValue?.stateGroup?.code || stateFormValue?.stateGroup?.isdCode || '',
          Telephone: formValue.telephone || '',
          AnnualBudget: this.corporateInfo.AnnualBudget,
          PostalCode: this.corporateInfo.PostalCode,
          Gender: formValue.gender || '',
          hasCompanyDomain: this.corporateInfo.hasCompanyDomain,
          taxIdentifcationNo: this.corporateInfo.taxIdentifcationNo,
          documentType: formValue.documentType || '',
          docExpiry: this._CommonService.formatDateToYMD(formValue.docExpiry),
          domainName: this.corporateInfo.domainName,
          buildingNumber: this.corporateInfo?.BuildingNo,
          districtName: this.corporateInfo?.district,

          // ✅ ADD OTP CHECKSUM HERE
          otpChecksum: this.otpChecksum,

          actionType: OtpActionType.REGISTER
        };
        this._DataLayerService.onclick_joinNow(registrationModel);
        this.popUp(registrationModel);
        this.commonObj.isSubmitting = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      error: () => {
        this._ToastrApiService.show('error', 'Failed to send OTP. Please try again.');
        this.commonObj.isSubmitting = false;
        this.otpsendverify = false;
      }
    });
  }

  sendOTP() {

    const formValue = this.businessOwnerForm.getRawValue();
    const token = localStorage.getItem('access_token');
    const sessionID = localStorage.getItem('session_id');

    const payload: OtpRequestPayload = {
      type: formValue.verifyWith == 'SMS' ? 'mobile' : 'email',
      otpAction: "mobileOrEmailValidation",
      value: formValue.verifyWith == 'Email' ? formValue.email : formValue.phoneNumber,
      channel: formValue.verifyWith == 'SMS' ? 'mobile' : 'email',
      companyId: "SAA",
      b2BId: null,
      b2BUserId: null,
      eventName: "REGISTRATION",
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      companyName: this.corporateInfo?.companyName || '',
    };

    return this.Utills.sendOTPV1(token, sessionID, payload);
  }




  onEmailBlur(): void {
    if (this.corporateInfo) {
      this.validateEmailDomain();
    }
    // Also check email existence on blur
    const emailControl = this.businessOwnerForm.get('email');
    if (emailControl?.value) {
      this.checkEmail({ target: { value: emailControl.value } });
    }
  }
  checkEmail(event: any): void {
    // Handle both event objects and direct email strings
    let email: string;
    if (typeof event === 'string') {
      email = event;
    } else if (event?.target?.value) {
      email = event.target.value;
    } else if (event?.value) {
      email = event.value;
    } else {
      // Try to get email from form control if event doesn't have value
      const emailControl = this.businessOwnerForm.get('email');
      email = emailControl?.value;
    }
    if (!email || !email.trim()) {
      return;
    }
    this.parallelAPICalls(email);
  }
  parallelAPICalls(email: string): void {
    const companyID = 'SAA';
    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    // Create observables for both API calls
    const checkEmail$ = this.Utills.CheckEmail(companyID, email);
    const fetchMatching$ = this.Utills.isAvailableLogin(sessionID, token, {
      loginID: email,
    });
    // Execute both in parallel
    forkJoin({
      emailCheck: checkEmail$,
      matchingData: fetchMatching$,
    }).subscribe({
      next: (results: any) => {
        console.log(results)
        const emailControl = this.businessOwnerForm.get('email');
        if (!emailControl) {
          return;
        }
        // Get current errors
        const currentErrors = { ...(emailControl.errors || {}) };
        // Handle email check result
        const fetchMatch = (results?.data?.isAvailable) ? true : false;
        const emailExists =
          results.emailCheck || fetchMatch
        if (emailExists) {
          console.log("if block")
          // Add emailExists error, preserve all other errors (including domainMismatch)
          emailControl.setErrors({ ...currentErrors, emailExists: true });
        } else {
          console.log("else block")
          // Remove only emailExists error, preserve all other errors
          if (currentErrors['emailExists']) {
            const { emailExists, ...remainingErrors } = currentErrors;
            emailControl.setErrors(
              Object.keys(remainingErrors).length ? remainingErrors : null
            );
          }
        }
        // Re-validate domain after email existence check
        if (this.corporateInfo) {
          this.validateEmailDomain();
        }
      },
      error: (error) => {
        console.error('Error in parallel API calls:', error);

        // Check for REG-019 error code
        const hasReg019Error = error?.error?.details?.some?.(
          (detail: any) => detail?.code === "REG-019"
        );

        if (hasReg019Error) {
          console.log("REG-019 error detected - email exists");
          const emailControl = this.businessOwnerForm.get('email');
          if (emailControl) {
            const currentErrors = { ...(emailControl.errors || {}) };
            emailControl.setErrors({ ...currentErrors, emailExists: true });
          }
        }
        console.error('Error in parallel API calls:', error);
        // Still validate domain even if email check fails
        if (this.corporateInfo) {
          this.validateEmailDomain();
        }
      },
    });
  }
  groupCountries(data: any): void {
    if (!this.countriesLists?.length) {
      this.countriesLists = data;
    }
    this.filteredCountries = data;
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = this.filteredCountries?.reduce((acc: any, country: any) => {
      const firstLetter = country.countryName[0].toUpperCase(); // Use countryName instead of Country
      if (!acc[firstLetter]) {
        acc[firstLetter] = [];
      }
      acc[firstLetter].push({
        name: country.countryName,
        code: country.isoCode,
        isdCode: country.code,
        countryFlag: country.newFlag.src,
      });
      return acc;
    }, {} as { [key: string]: { name: string; code: string; isdCode: string; countryFlag: string }[] });
    if (this.filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b)
      );
      const saudiGroup = grouped['S']?.find((c) => c.name === 'Saudi Arabia');
      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter((c) => c.name !== 'Saudi Arabia');
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];
        const index = sortedGroupLetters.indexOf('S');
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
        sortedGroupLetters.unshift('S');
      }
      // Wrap the result in `of()` to make it an Observable
      this.stateGroupOptions = of(
        sortedGroupLetters.map((letter) => {
          return {
            letter: letter,
            names: grouped[letter],
          };
        })
      );
    }
  }
  nationalityGroupCountries(data: any, value?: any): void {
    let currentState: any[] = [];
  
    if (value) {
      const searchValue = value.toString().toLowerCase();
  
      currentState = this.countriesLists.filter(
        ($country: any) =>
          $country.countryName?.toLowerCase().includes(searchValue)
      );
    }
  
    if (!this.countriesLists?.length) {
      this.countriesLists = value ? currentState : data;
    }
  
    const filteredCountries = value ? currentState : data;
  
    const grouped: {
      [key: string]: {
        name: string;
        code: string;
        isdCode: string;
        countryFlag: string;
      }[];
    } = filteredCountries?.reduce(
      (acc: any, country: any) => {
        const firstLetter = country.countryName[0].toUpperCase();
  
        if (!acc[firstLetter]) {
          acc[firstLetter] = [];
        }
  
        acc[firstLetter].push({
          name: country.countryName,
          code: country.isoCode,
          isdCode: country.code,
          countryFlag: country.newFlag.src,
        });
  
        return acc;
      },
      {} as {
        [key: string]: {
          name: string;
          code: string;
          isdCode: string;
          countryFlag: string;
        }[];
      }
    );
  
    if (filteredCountries) {
      const sortedGroupLetters = Object.keys(grouped).sort((a, b) =>
        a.localeCompare(b)
      );
  
      const saudiGroup = grouped['S']?.find(
        (c) => c.name === 'Saudi Arabia'
      );
  
      if (saudiGroup) {
        grouped['S'] = grouped['S'].filter(
          (c) => c.name !== 'Saudi Arabia'
        );
  
        grouped['S'] = [
          {
            name: 'Saudi Arabia',
            code: 'SA',
            isdCode: '+966',
            countryFlag:
              '/-/media/SaudiaWebApp/data/media/img/Flags/Latest-flags/Flag-saudi_arabia.ashx?rev=856c905ee3344e1295e5948ae4d64d9a',
          },
          ...grouped['S'],
        ];
  
        const index = sortedGroupLetters.indexOf('S');
  
        if (index > -1) {
          sortedGroupLetters.splice(index, 1);
        }
  
        sortedGroupLetters.unshift('S');
      }
  
      this.NationalityOptions = of(
        sortedGroupLetters.map((letter) => ({
          letter,
          names: grouped[letter],
        }))
      );
    }
  }
  displayFn1 = (option: { name: string; code: string } | null): string => {
    if (option) {
      // Update document type first, then verify ELM
      this.updateDocumentType();
      this.verifyELM(option.code);
      return option.name; // Return the name after calling verifyELM
    }
    return '';
  };
  filterCountries(value: any): void {
    const searchField =
      value?.stateGroup?.split('+')?.length === 1
        ? 'countryName'
        : 'code';
  
    const searchValue = (value?.stateGroup || '')
      .replace('+', '')
      .toLowerCase();
  
    const currentState: any[] = this.countriesLists.filter(
      ($country: any) =>
        $country[searchField]
          ?.toString()
          .toLowerCase()
          .includes(searchValue)
    );
  
    this.groupCountries(currentState);
  
    if (currentState.length < 2) {
      this.PreviousCountryCode = currentState;
    }
  }
  getFormattedDate(date: Date | null): string | null {
    if (!date) return null;
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2-digit day
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  isDOBInvalid(): boolean {
    const dobControl = this.businessOwnerForm.get('DOB') as FormControl;
    if (!dobControl || dobControl.invalid) {
      return false; // No DOB or invalid control, so no validation needed
    }
    const dobValue = dobControl.value;
    if (!dobValue) {
      // dobControl.setErrors({ required: true });
      return false;
    }
    let dobString: string;
    // Check if the value is a Date object or a string
    if (dobValue instanceof Date) {
      // Convert the Date object to a string in "dd/MM/yyyy" format
      const day = dobValue.getDate().toString().padStart(2, '0');
      const month = (dobValue.getMonth() + 1).toString().padStart(2, '0'); // JavaScript months are 0-indexed
      const year = dobValue.getFullYear();
      dobString = `${day}/${month}/${year}`;
    } else {
      dobString = dobValue;
    }
    // Validate the format of the DOB string using a regex for "dd/MM/yyyy"
    const dobFormatRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dobFormatRegex.test(dobString)) {
      dobControl.setErrors({ invalidFormat: true });
      return false; // Invalid format
    }
    // Split the DOB string
    const dobParts = dobString.split('/');
    const day = parseInt(dobParts[0], 10);
    const month = parseInt(dobParts[1], 10) - 1; // JavaScript months are 0-indexed
    const year = parseInt(dobParts[2], 10);
    // Construct a valid Date object from the parsed parts
    const dobDate = new Date(year, month, day);
    // Check if the constructed date is valid
    if (
      isNaN(dobDate.getTime()) ||
      dobDate.getDate() !== day ||
      dobDate.getMonth() !== month ||
      dobDate.getFullYear() !== year
    ) {
      dobControl.setErrors({ invalidFormat: true });
      return false; // Invalid date
    }
    // Set the minDate as 12 years back from the current date
    const today = new Date();
    const maxDate = new Date(
      today.getFullYear() - 12,
      today.getMonth(),
      today.getDate()
    );
    const minDate = new Date(1942, 0, 1);
    // Validate DOB against the minDate
    if (dobDate > maxDate || dobDate < minDate) {
      dobControl.setErrors({ invalidAdultDOB: true });
      return false;
    }
    // If everything is valid, clear all errors
    dobControl.setErrors(null);
    return true;
  }
  displayFn(
    option: { name: string; code: string; isdCode: string } | null
  ): string {
    // this.PreviousCountryCode=option ? option?.isdCode ?? option: '';
    this.mobilecode = option;
    return option ? option?.isdCode ?? option : '';
  }
  onlyNumbersValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      const isValid = /^[\d+]*$/.test(value); // Allows only digits and '+'  VerificationMode
      return isValid ? null : { forbiddenCharacters: { value: control.value } };
    };
  }
  passwordStrengthValidator(control: AbstractControl) {
    const password = control.value;
    if (!password) return null;
    const validations = [
      this.isValidLength(password),
      this.hasUppercase(password),
      this.hasLowercase(password),
      this.hasNumeric(password),
      this.hasSpecialChar(password),
    ];
    return validations.every((v) => v) ? null : { weakPassword: true };
  }
  isValidLength(password: string): boolean {
    return password.length >= 8;
  }
  hasUppercase(password: string): boolean {
    return /[A-Z]/.test(password);
  }
  hasLowercase(password: string): boolean {
    return /[a-z]/.test(password);
  }
  hasNumeric(password: string): boolean {
    return /\d/.test(password);
  }
  hasSpecialChar(password: string): boolean {
    return /[!@#$%^&*(),.?":{}|<>_\-]/.test(password);
  }
  blockInvalidCharactersForDOB(event: KeyboardEvent): void {
    // Allow numbers (0-9), hyphen (-), slash (/), and backspace
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '/',];
    // Prevent invalid characters
    if (!allowedKeys.includes(event.key) && event.key !== 'Backspace') {
      event.preventDefault();
    }
  }
  checkPasswordMatch() {
    this.checkInvalidControls(this.businessOwnerForm);
    this.checkInvalidControls(this.stateForm);
    const password = this.businessOwnerForm.get('newPassword')?.value;
    const confirmPassword =
      this.businessOwnerForm.get('confirmPassword')?.value;
    if (!password || !confirmPassword) {
      this.businessOwnerForm
        .get('confirmPassword')
        ?.setErrors({ required: true });
    } else if (password && confirmPassword && password == confirmPassword) {
      this.businessOwnerForm.get('confirmPassword')?.setErrors(null);
    } else if (password || (confirmPassword && password !== confirmPassword)) {
      this.businessOwnerForm
        .get('confirmPassword')
        ?.setErrors({ mismatch: true });
    } else {
      this.businessOwnerForm.get('confirmPassword')?.setErrors(null);
    }
  }
  updateSelectedCountry(country: { name: string; code: string }) {
    this.selectedCountryName = country.name; // Update the selected country name
  }
  openRegistrationVerifyingEmailComponent(
    email: string | null = null,
    OTP: string | null = null
  ): void {
    this.dialog.open(RegistrationVerifyingEmailComponent, {
      disableClose: true,
      data: { email, OTP }, //CID, Language , Mode, Subagent_ID
    });
  }
  togglePasswordVisibility(event: MouseEvent) {
    event.preventDefault(); // Prevent default form submission
    this.hideNewPassword = !this.hideNewPassword; // Toggle newPassword visibility
  }
  // Function to toggle confirm password visibility
  togglePasswordVisibility1(event: MouseEvent) {
    event.preventDefault(); // Prevent default form submission
    this.hideConfirmPassword = !this.hideConfirmPassword; // Toggle confirmPassword visibility
  }
  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];
    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  blockSpecialCharAndNumbers(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ':', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '@', '=', '%', '(', ')', '{', '}', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  blockNumbers(event: KeyboardEvent): void {
    // Allow only alphabetic characters and spaces
    if (!/^[a-zA-Z\s]$/.test(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }
  Onlyrs(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentInputValue = inputElement.value;
    // If the length is 64 or more, prevent further input
    if (currentInputValue.length >= 64) {
      event.preventDefault();
      return;
    }
    // Get the character being typed
    const typedChar = event.key;
    // If the character is a dot, check if the previous character was also a dot
    if (typedChar === '.' && currentInputValue.endsWith('.')) {
      this.businessOwnerForm
        .get('email')
        ?.setErrors({ customEmailValidator: true });
      event.preventDefault(); // Prevent input if consecutive dots are found
    }
  }
  checkFields() {
    const nationalID = this.businessOwnerForm.get('NationalID');
    const Nationality = this.businessOwnerForm.get('Nationality');
    if (nationalID?.value || Nationality?.value) {
      Nationality?.setValidators([Validators.required]);
      nationalID?.setValidators([
        inputValidationValidator(),
        Validators.minLength(8),
        Validators.maxLength(16),
        Validators.required,
      ]);
    } else {
      nationalID?.removeValidators([Validators.required]);
      Nationality?.removeValidators([Validators.required]);
    }
    // Only update validity when validators are changed
    nationalID?.updateValueAndValidity();
    Nationality?.updateValueAndValidity();
  }
  checkInvalidControls(form: FormGroup): void {
    // Iterate over each control in the form group
    Object.keys(form.controls).forEach((controlName) => {
      const control = form.get(controlName);
      if (control && control.invalid) {
      }
    });
  }
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }
  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }
  storeSelectedNationalityValue(value: any) {
    this.PrevNationality = value.name;
  }
  validateNationality(data: any) {
    const countryControl = this.businessOwnerForm.get(
      'Nationality'
    ) as FormControl;
    // If nationality is selected (non-empty), clear any existing errors
    if (this.changedNationality?.name) {
      countryControl.setErrors(null);
    }
    // Check if PrevNationality is empty first
    else if (
      this.PrevNationality &&
      this.PrevNationality !== this.changedNationality &&
      !!this.changedNationality
    ) {
      // Only set the error if PrevNationality has a value and differs from changedNationality
      countryControl.setErrors({ invalidNationality: true });
    } else if (!this.changedNationality || this.changedNationality == '') {
      // Only set the error if PrevNationality has a value and differs from changedNationality
      countryControl.setErrors(null);
      return;
    }
    // If nationality is empty, clear any previous errors
    else if (!this.changedNationality?.name) {
      countryControl.setErrors(null);
    }
  }
  convertToISODate(dob: string): string {
    if (!dob) return '';
    // Split the date into day, month, and year
    const dateParts = dob.split('/');
    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob; // If the format is incorrect, return the original string
  }
  formatDOB(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  }
  onDOBFocusOut(event: FocusEvent, controlName: string): void {
    // Focus moved outside; close calendar
    this.isChildVisible['isDOBCalendarVisible'] = false;
    this.businessOwnerForm.get('DOB')?.setValidators([Validators.required]);
    this.businessOwnerForm.get('DOB')?.updateValueAndValidity();
  }
  emailIDblockInvalidCharacters(
    event: KeyboardEvent,
    inputValue: string
  ): void {
    const key = event.key;
    // Split input into "before @" and "after @"
    const atIndex = inputValue.indexOf('@');
    const isBeforeAt = atIndex === -1 || inputValue.length <= atIndex;
    if (isBeforeAt) {
      // Allowed before @ : letters, digits, . _ % + -
      const allowedPattern = /^[a-zA-Z0-9._%+-]$/;
      if (!allowedPattern.test(key)) {
        event.preventDefault();
      }
    } else {
      // Allowed after @ : letters, digits, . -
      const allowedPattern = /^[a-zA-Z0-9.-]$/;
      if (!allowedPattern.test(key)) {
        event.preventDefault();
      }
    }
  }
  private normalizeUrl(raw: any): string | undefined {
    if (!raw) return undefined;
    let url = String(raw).trim();
    if (!url) return undefined;
    // Add https:// if missing
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }
    return url;
  }
  //GTM use
  onRadioChange(event: MatRadioChange) {
    this._DataLayerService.onclick_email_phone(event.value);
    this.businessOwnerForm.get('verifyWith')?.setValue(event.value)
  }
  //GTM use
  onCheckboxChange(event: MatCheckboxChange) {
    if (event.checked) {
      this._DataLayerService.checkbox_Term_and_condition('checkbox-TC_checked'); //GTM Use
    } else {
      this._DataLayerService.checkbox_Term_and_condition(
        'checkbox-TC_unchecked'
      );
    }
  }
  renderHCaptcha() {
    const captchaElement = document.querySelector(
      '.h-captcha'
    ) as HTMLElement | null;
    if (!captchaElement) {
      console.error('Captcha element not found.');
      return;
    }
    if (!window.hcaptcha) {
      return;
    }
    window.hcaptcha.render(captchaElement, {
      sitekey: this.Sitekey,
      callback: (token: string) => this.handleCaptchaSuccess(token),
      theme: 'light',
      size: 'normal',
    });
  }
  handleCaptchaSuccess(token: string) {
    console.log('Captcha token:', token);
    this.accountService.verifyHCaptcha(token).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.afterCaptchaPassed();
        } else {
          console.log('Captcha verification failed.');
        }
      },
      error: (err: any) => console.error('Captcha verification error:', err),
    });
  }
  afterCaptchaPassed() {
    console.log('Continue your next logic here...');
  }
  getSiteCoreArray(keyString: string): Array<any> {    
    return this.content?.[keyString];
  }
  get filteredTitles(): Array<any> {
    const titles = this.getSiteCoreArray('b2b.register.titledropdown');
    if (titles && Array.isArray(titles)) {
      return titles.filter(option => option.Key !== 'miss' && option.Key !== 'mstr');
    }
    return [];
  }

  updatePhoneNumberValidators() {
    const phoneControl = this.businessOwnerForm.get('phoneNumber');
    const selectedCountry = this.stateForm.get('stateGroup')?.value;
    const countryCode = selectedCountry?.code;

    // Check if India (ISD code +91 or 91)
    const isIndia = countryCode === '+91' || countryCode === '91';

    if (isIndia) {
      // India: exactly 10 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.pattern(/^\d{10}$/),
   
      ]);
    } else {
      // Other countries: 6 to 12 digits
      phoneControl?.setValidators([
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(12)
      ]);
    }

    phoneControl?.updateValueAndValidity();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  trimField(field: string) {
    const control = this.businessOwnerForm.get(field);
    if (control?.value) {
      control.setValue(control.value.trim());
    }
  }

  getCountryNameByCode(code: string): string {
  if (!code || !this.countriesLists?.length) {
    return '';
  }

  const country = this.countriesLists.find(
    (item: any) => item.isoCode === code
  );

  return country?.countryName || '';
}
}


